<template>
  <v-form class='createProjectForm' v-model='valid' ref='createProjectForm'>
    <v-container class='mb-10'>
      <div>
        <!-- Row Delete Dialouge -->
        <v-dialog v-model="deleteRowConfirm" width="600">
          <v-card>
            <v-card-title class="headline">Are you sure?</v-card-title>
            <v-card-text>Are you sure you want delete this row?</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="removeMaterial">Yes</v-btn>
              <v-btn color="primary" text @click="deleteRowConfirm = false; deleteRow = ''">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Row Delete Dialouge -->
      </div>
      <h4>Project Details</h4>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12" class="d-none">
          <module-prefix :module="'project'" :prefix.sync="project.prefix" :no.sync="project.no" v-if="!project.id"/>
          <v-text-field
            v-model="project.prefix"
            label='Prefix'
            placeholder='Prefix'
            v-if="project.id"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12" class="d-none">
          <v-text-field
          v-model='project.no'
          :error-messages='error.no'
          label='No'
          placeholder='No'
          readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            label='Project No'
            placeholder='Project No'
            :value="bindProjectNo"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="project.start_date"
            :error-messages="error.start_date"
            type="date"
            label="Start Date"
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="project.estimated_end_date"
            :error-messages="error.estimated_end_date"
            type="date"
            label="Estimated End Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="project.end_date"
            :error-messages="error.end_date"
            type="date"
            label="End Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="project.ptwp_id" :options="{ url: 'welding_procedure', label: 'Assigned WPS', multiple: true, returnType: 'object' }" :errorMessage="error.ptwp_id" :selectedData="project.ptwp_id"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-autocomplete
            v-model="project.status"
            item-value="id"
            :items="[ {id: 'pending', text: 'Pending'}, {id: 'open', text: 'Open'}, {id: 'approved', text: 'Approved'}, {id: 'complete', text: 'Complete'}, {id: 'in_active', text: 'Inactive'}]"
            :error-messages='error.status'
            label="Status"
            placeholder='Status'
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-textarea
            v-model="project.remark"
            label="Remark"
            placeholder="Remark"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-textarea
            v-model="project.description"
            label="Desciption"
            placeholder="Desciption"
            rows="2"
          ></v-textarea>
        </v-col>
      </v-row>
      <h4>Material Details</h4>
      <v-row v-if="error.project_material ? error.project_material[0] : false">
        <v-col cols="12" md="12" sm="12" xs="12" class="py-0">
          <span class="red--text">{{ error.project_material ? error.project_material[0] : '' }}</span>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in project.project_material" :key="index">
        <v-col cols="12" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <v-text-field
                label="Material"
                placeholder="Material"
                v-model="project.project_material[index].material"
                :error-messages="error[`project_material.${index}.material`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <v-text-field
                label="Quantity"
                placeholder="Quantity"
                v-model="project.project_material[index].quantity"
                :error-messages="error[`project_material.${index}.quantity`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0">
              <v-text-field
                label="Unit"
                placeholder="Unit"
                v-model="project.project_material[index].unit"
                :error-messages="error[`project_material.${index}.unit`]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6" xs="12" class="pt-0 pb-0 pb-md-3">
              <v-text-field
                label="Price"
                placeholder="Price"
                v-model="project.project_material[index].price"
                :error-messages="error[`project_material.${index}.price`]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="1" md="1" sm="12" xs="12" align-self="center" class="pt-0">
          <v-row>
            <v-col cols="12" class="text-center">
              <v-icon @click="removeMaterialConfirm(index)" v-if="!$vuetify.breakpoint.mdAndDown">mdi-delete-circle</v-icon>
              <v-btn @click="removeMaterialConfirm(index)" small block v-else>Delete</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" class="pb-5">
          <v-btn color="primary" class="mr-2" @click="addMaterial" small :block="$vuetify.breakpoint.mdAndDown">Add Material</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    bindProjectNo () {
      return this.project.prefix + ((this.project.no ? this.project.no : '').toString().padStart(4, '0'))
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.getDataById(id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        this.getDataById(_storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      project: { project_material: [], prefix: '', no: '' },
      error: {},
      deleteRowConfirm: false,
      deleteRow: ''
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getProjectById/' + id).then((res) => {
        const data = res.data.project
        data.project_material = res.data.project_material
        data.ptwp_id = res.data.ptwp
        this.project = data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveProject/' + this.edit_id : 'saveProject'
        this.$axios.post(route, this.project).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/project')
          } else {
            const resData = res.data.data
            this.reset(resData)
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
            console.log(err.response.data.error_data)
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createProjectForm.validate()
      }
    },
    reset (resData = {}) {
      // when form reset set old prefix and no for continute the sequence
      const oldPrefix = resData.prefix
      const oldSrNo = resData.no
      this.$refs.createProjectForm.reset()
      setTimeout(() => {
        this.project = { project_material: [], prefix: oldPrefix, no: oldSrNo }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
    addMaterial () {
      this.project.project_material.push({ material: '', quantity: '', unit: '', price: '' })
    },
    removeMaterialConfirm (index) {
      this.deleteRowConfirm = true
      this.deleteRow = index
    },
    removeMaterial () {
      if (this.deleteRow !== '') {
        this.deleteRowConfirm = false
        this.project.project_material.splice(this.deleteRow, 1)
        this.deleteRow = ''
      }
    }
  },
}
</script>

<style>
.createProjectForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createProjectForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
